import React from "react";
import { Box, Typography } from "@material-ui/core";
import "./case-preview-header.component.scoped.scss";

interface CasePreviewHeaderProps { }

const CasePreviewHeaderComponent = (props: CasePreviewHeaderProps) => {
  return (
    <Box className="content">
      <Typography variant="h6" color="primary">
        AI Conformity Declaration
      </Typography>
      <img src="/icons/logos/pAIper-dark.png" alt="pAIper-one" />
    </Box>
  );
};

export default CasePreviewHeaderComponent;
